/* global HSCore */


import React, { useContext, useEffect, useRef } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";

function Preferences() {
  //   const navigate = useNavigate();
  const { t, language, languageOptions } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  //   const { userData } = useContext(UserContext);
  //   const [isChecked, setIsChecked] = useState(false);

  //   const handleCheckboxChange = () => {
  //     setIsChecked((prev) => !prev);
  //   };

  //   const handleDeleteWebsite = () => {
  //     const url = `/sellers/${userData?.uuid}/terms/${termsData?.terms?.uuid}`;
  //     axiosInstance
  //       .delete(url)
  //       .then(() => {
  //         navigate("/websites");
  //         toast.success(t("Website deleted successfully"));
  //       })
  //       .catch(() => {
  //         toast.error(t("There was an error deleting the Website"));
  //       });
  //   };
 
 const jsSelectInitRef = useRef(null);
  useEffect(() => {
    if (!jsSelectInitRef.current) {
      HSCore.components.HSTomSelect.init('.js-select');
      // eslint-disable-next-line react-hooks/exhaustive-deps
      jsSelectInitRef.current = true;
    }
  }, []);

  return (
    <div id="Preferences" className={`card cardSetting ${themeStatus?.[selectedTheme]}`}>
      <div className="card-header">
        <h4
          className="card-title responsive-title">
          {t("Preferences")}
        </h4>
      </div>

      <div className="card-body">
          <div className="d-flex w-100 justify-content-between align-items-center mt-3">
            <label className="form-label card-text" style={{color:"var(--whiteToBlack)"}}>
              {t("Language")}
            </label>
            <div className="tom-select-custom tom-select-custom-end tom-select-custom-bg-transparent" style={{width:"65%"}}>
                    <select
                      className="js-select form-select form-select-sm card-text"
                      data-hs-tom-select-options='{
                        "searchInDropdown": false,
                        "hideSearch": true,
                        "dropdownWidth": "100%"
                      }'
                      id="tomselect-2"
                      value={language} // Use the context's language state
                      // onChange={(e) => changeLanguage(e.target.value)} // Use onChange
                    >
                      {Object.keys(languageOptions).map((lng) => (
                        <option
                          key={lng}
                          value={lng}
                          data-option-template={`<span class="d-flex align-items-center">
                            <img class="avatar avatar-xss avatar-circle me-2" 
                                src="${languageOptions[lng].flag}" 
                                alt="${languageOptions[lng].name} Flag" 
                                width="16"/>
                            <span>${languageOptions[lng].name}</span>
                          </span>`}
                        >
                          {languageOptions[lng].name}
                        </option>
                      ))}
                    </select>
                  </div>
          </div>
          <div className="d-flex w-100 justify-content-between align-items-center mt-3">
            <label className="form-label card-text" style={{color:"var(--whiteToBlack)"}}>
              {t("Time Zone")}
            </label>
            <div style={{ width: "65%" }}>
              <input
                type="text"
                className="form-control account-placeholder rounded-2 "
                placeholder={t("GMT +1:00")}
                name="nameOnCard"
                // value={formValues.nameOnCard}
                // onChange={handleCardDetails}
                
              />
            </div>
          </div>
      </div>
      <div className="card-header p-0"></div>
      <div className="d-flex justify-content-end card-body pt-3">
        <button
          className="btn btn-primary edit-profile-btn p-0"
          //   onClick={handleDeleteWebsite}
          //   disabled={!isChecked}
        >
          {t("Save Changes")}
        </button>
      </div>
    </div>
  );
}

export default Preferences;
